
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("j2wbB", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=es.b9ed4785.js.map
